export function GettingStarted() {
    const steps = [
        {
            number: 1,
            title: 'Choose Your Platform',
            description: 'ChatGPT, Claude.ai, Claude Desktop, or VS Code Copilot'
        },
        {
            number: 2,
            title: 'Add Server URL',
            description: 'Configure your client with the MCP server endpoint'
        },
        {
            number: 3,
            title: 'Start Using',
            description: 'Search flights, check statuses, manage bookings, and explore destinations'
        }
    ];

    return (
        <section id="getting-started" className="mx-auto max-w-7xl px-4 py-12 sm:px-6 md:py-20 lg:px-8" aria-labelledby="getting-started-heading">
            <div className="mb-12 text-center">
                <h2 id="getting-started-heading" className="mb-4 text-3xl font-bold text-[#F8FAFC] md:text-4xl">
                    Get Started in 3 Steps
                </h2>
                <p className="mx-auto max-w-2xl text-lg text-[#CBD5E1]">Connect your AI assistant to Turkish Airlines in minutes</p>
            </div>

            <div className="mx-auto grid max-w-5xl gap-8 md:grid-cols-3">
                {steps.map((step) => (
                    <div key={step.number} className="text-center">
                        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-[#E81932] to-[#C41E3A] text-2xl font-bold text-white shadow-lg shadow-[#E81932]/20">{step.number}</div>
                        <h3 className="mb-3 text-xl font-semibold text-[#F8FAFC]">{step.title}</h3>
                        <p className="leading-relaxed text-[#CBD5E1]">{step.description}</p>
                    </div>
                ))}
            </div>
        </section>
    );
}
